import { FieldNode } from "../types";
import { ArrayField } from "./ArrayField";
import { MapField } from "./MapField";
import { NullableObjectField } from "./NullableObjectField";
import { ObjectField } from "./ObjectField";
import { OneOfField } from "./OneOfField";
import { PrimitiveField } from "./PrimitiveField";
import { UnionField } from "./UnionField";

/**
 * The field for a node without its enable switch (the parent shows the title and the switch).
 * With `bare`, a primitive, list or map also has no label.
 */
export const FieldBody = ({
  node,
  bare = false,
}: {
  node: FieldNode;
  bare?: boolean;
}) => {
  switch (node.kind) {
    case "object":
      return <ObjectField node={node} bare />;
    case "oneOf":
      return <OneOfField node={node} />;
    case "union":
      return <UnionField node={node} />;
    case "array":
      return <ArrayField node={node} bare={bare} />;
    case "map":
      return <MapField node={node} bare={bare} />;
    case "primitive":
      return <PrimitiveField node={node} bare={bare} />;
  }
};

/**
 * The field for a node inside an object: an optional object or union of objects gets an enable switch,
 * any other object shows its title and a border.
 */
export const FieldRenderer = ({ node }: { node: FieldNode }) => {
  const optional = node.nullable && !node.required;

  if ((node.kind === "object" || node.kind === "oneOf") && optional) {
    return <NullableObjectField node={node} />;
  }

  if (node.kind === "object") {
    return <ObjectField node={node} />;
  }

  return <FieldBody node={node} />;
};
